export function setBodyOverflowHidden(isSet: boolean) {
    const body = document.body

    body.classList.toggle('overflow-hidden', isSet)
}
